import type { MerchantColumnFilters } from '../models/types';

export const ACCENT_COLORS = [
  '#5c6bc0', '#26a69a', '#ffa502', '#ff6b6b', '#a78bfa', '#2ed573', '#ff9f43',
];

export const SEARCH_DEBOUNCE_MS = 400;

export const EMPTY_MERCHANT_COLUMN_FILTERS: MerchantColumnFilters = {
  name: null,
  email: null,
  country: null,
  status: null,
  website: null,
  industry: null,
  createdAt: null,
};

export const KYC_LABELS: Record<string, string> = {
  APPROVED: 'Verified',
  REJECTED: 'Rejected',
  UNDER_REVIEW: 'Under Review',
  PENDING: 'Pending',
};
